<mat-form-field [appearance]="appearance!">
  <mat-icon matPrefix *ngIf="icon">
    {{ icon }}
  </mat-icon>
  <mat-label>{{ label }}</mat-label>
  <textarea type="text" matInput [formControlName]="name"></textarea>
</mat-form-field>